import React, {Component} from 'react';
import cx from 'classnames';

export default class TeamMemberHover extends Component {
    constructor(){
        super();
        this.setIsActive = this.setIsActive.bind(this);
        this.setIsNotActive = this.setIsNotActive.bind(this);
        this.state = {
            isActive: false
        }
    }

    setIsActive(){
        this.setState({
            isActive: true
        });
    }

    setIsNotActive(){
        this.setState({
            isActive: false
        });
    }

    render(){
        const {isActive} = this.state;
        const {name, title, info, imgPath, logoPath} = this.props;
        const classname = cx('gr-2', 'team-member-hover', {'team-member-hover-is-active': isActive});
        const style = {
            backgroundImage: `url(${imgPath})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
        };

        return(
            <div
                className={classname}
                style={style}
                onMouseEnter={this.setIsActive}
                onMouseLeave={this.setIsNotActive}>
                <div className='team-member-hover-name'>
                    <h2>{name}</h2>
                </div>
                <div className='team-member-hover-filter' style={style}></div>
                <div className='team-member-hover-bio'>
                    <h2>{name}</h2>
                    <h3>{title}</h3>
                    <p className='selected-member-info'>
                        {info}
                    </p>
                    <img src={logoPath} />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/meet_the_team/team_member_hover.js